import { combineReducers } from '@reduxjs/toolkit';
import { shareProgramSlice } from './program-share';
import { recommendProgramSlice } from './recommend-program';

export { useFavorite } from './favorite';
export { useProgramShare, ModalShare } from './program-share';
export { useOpenEditor } from './program-edit';
export { useProgramDelete } from './program-delete';
export { useRecommendModal, ModalRecommend } from './recommend-program';
export { useProgramLoader, useProgramVideos, useProgramAuthor } from './program';

export { useEditorForm, useFormSubmit } from './editor-form';
export { DnDList, DnDCard, Periodicity, AddPromoCard, SearchParams } from './editor-form';
export type { ProgramEditorValues } from './editor-form';

export { ModalBuy } from './buy-program';
export { useUpdateRecommendation, Recommendation, Comment } from './recommendation';
export { ListQuery, useMobileVisibilityFilter } from './program-list';

export { RentalStatus } from './rental-status';

export { ProgramPromo } from './promo';
export * from './program-history';
export const programFeatureReducers = combineReducers({
  recommend: recommendProgramSlice.reducer,
  share: shareProgramSlice.reducer,
});
